import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-customers',
  storeModule.createStoreModule('active-offers-customers', {
    fetchSingleURL: 'active-offers/customers/new'
  })
)
